<template>
  <div class="ov-page">
    <div class="ov-header">
      <div>
        <h1 class="ov-header__title">{{ $t('station.viewStations') }}</h1>
        <p class="ov-header__subtitle mt-1">{{ $t('station.viewStationsSubtitle') }}</p>
      </div>
    </div>

    <!-- Sélecteur de compagnie (admin uniquement) -->
    <div v-if="$store.state.userAuthentified.roleCode == 'RoleAdminSocieteMere'" class="ov-card mb-6">
      <div class="ov-card__body">
        <div class="ov-field gs-company">
          <label class="ov-label">{{ $t('station.filterByCompany') }}</label>
          <select
            v-model="compagnieTransportRaisonSociale"
            class="ov-select"
            @change="getAllAvailableStationByCompagnie(compagnieTransportRaisonSociale)"
          >
            <option :value="null" disabled>{{ $t('station.selectCompany') }}</option>
            <option v-for="c in compagnieTransportList" :key="c.raisonSociale" :value="c.raisonSociale">
              {{ c.raisonSociale }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Liste des gares -->
    <div
      v-if="$store.state.userAuthentified.roleCode !== 'RoleAdminSocieteMere' || cardForAvailableStationShowed"
      class="ov-card"
    >
      <div class="ov-card__head">
        <div class="ov-card__title">
          {{ $t('station.availableStationsList') }}
          <span class="ov-count">{{ gareDisponiblesList.length }}</span>
        </div>
        <div class="ov-search">
          <v-icon small>mdi-magnify</v-icon>
          <input v-model="search" type="text" class="ov-input" :placeholder="$t('station.search')" />
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="gareDisponiblesList"
        :loading="loading"
        :search="search"
        loader-height="2"
        class="ov-table"
        :loading-text="$t('station.loadingData')"
        :no-data-text="$t('station.noStationAvailable')"
      >
        <template v-slot:[`item.designation`]="{ item }">
          <span class="gs-designation">{{ item.designation }}</span>
        </template>
        <template v-slot:[`item.telephone1`]="{ item }">
          +225 {{ item.telephone1 }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="ov-row-actions">
            <button type="button" class="ov-icon-btn" :title="$t('station.edit')" @click="activeModeUpdating(item)">
              <v-icon small>mdi-pencil-outline</v-icon>
            </button>
          </div>
        </template>
      </v-data-table>
    </div>

    <!-- ===== DIALOGUE DE MODIFICATION ===== -->
    <v-dialog v-model="openDialogUpdatingStation" persistent max-width="640px">
      <div class="ov-dialog">
        <div class="ov-dialog__head gs-dialog-head">
          <div class="ov-dialog__title">{{ $t('station.editStation') }}</div>
          <button type="button" class="ov-icon-btn" :title="$t('station.cancel')" @click="closeDialogUpdatingStation()">
            <v-icon small>mdi-close</v-icon>
          </button>
        </div>

        <div class="ov-dialog__body">
          <div class="ov-note ov-note--info mb-5">
            <v-icon small>mdi-information-outline</v-icon>
            <span>{{ $t('station.requiredFields') }}</span>
          </div>

          <div class="ov-row">
            <div class="ov-field ov-col-full">
              <label class="ov-label">{{ $t('station.stationDesignation') }}<span class="ov-required">*</span></label>
              <input
                v-model="gareTransportModel.designation"
                type="text"
                class="ov-input"
                :placeholder="$t('station.stationPlaceholder')"
              />
            </div>
            <div class="ov-field ov-col-full">
              <label class="ov-label">{{ $t('station.email') }}<span class="ov-required">*</span></label>
              <input
                v-model="gareTransportModel.email"
                type="email"
                class="ov-input"
                :placeholder="$t('station.emailPlaceholder')"
              />
            </div>
            <div class="ov-field">
              <label class="ov-label">{{ $t('station.phone1') }}<span class="ov-required">*</span></label>
              <div class="ov-input-group">
                <span class="ov-input-prefix">+225</span>
                <input
                  v-model="gareTransportModel.telephone1"
                  type="tel"
                  class="ov-input"
                  :placeholder="$t('station.phonePlaceholder')"
                />
              </div>
            </div>
            <div class="ov-field">
              <label class="ov-label">{{ $t('station.phone2') }}</label>
              <div class="ov-input-group">
                <span class="ov-input-prefix">+225</span>
                <input
                  v-model="gareTransportModel.telephone2"
                  type="tel"
                  class="ov-input"
                  :placeholder="$t('station.phonePlaceholder')"
                />
              </div>
            </div>
            <div class="ov-field ov-col-full">
              <label class="ov-label">{{ $t('station.address') }}<span class="ov-required">*</span></label>
              <input
                v-model="gareTransportModel.adresseLocalisation"
                type="text"
                class="ov-input"
                :placeholder="$t('station.addressPlaceholder')"
              />
            </div>
          </div>
        </div>

        <div class="ov-dialog__foot">
          <button type="button" class="ov-btn ov-btn--secondary" @click="closeDialogUpdatingStation()">
            {{ $t('station.cancel') }}
          </button>
          <button type="button" class="ov-btn ov-btn--primary" @click="apiUpdateGareTransport">
            <v-icon small>mdi-content-save-outline</v-icon>
            {{ $t('station.save') }}
          </button>
        </div>
      </div>
    </v-dialog>

    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert>
    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="56" color="#159e72"></v-progress-circular></v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import apiService from "@/services/api.service";
import {
  API_CREER_GARE_COMPAGNIE_TRANSPORT,
  API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
  HEADERS,
} from "../../components/globalConfig/globalConstConfig";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../messages/messageProcess";
export default {
  name: "SelectionnerGareCompagnieTransport",
  data() {
    return {
      compagnieTransportList: [],
      compagnieTransportRaisonSociale: null,
      cardForAvailableStationShowed: false,
      openDialogUpdatingStation: false,
      overlay: false,
      errorMsg: null,
      successMsg: null,
      loading: true,
      search: "",
      headers: [
        { text: this.$t('station.reference'), value: "id" },
        { text: this.$t('adhesion.designation'), value: "designation" },
        { text: this.$t('station.email').replace(' *', ''), value: "email" },
        { text: this.$t('station.addressLabel'), value: "adresseLocalisation" },
        { text: this.$t('station.phone'), value: "telephone1" },
        { text: this.$t('station.actions'), value: "actions", sortable: false },
      ],

      gareTransportModel: {
        id: null,
        designation: null,
        email: null,
        telephone1: null,
        telephone2: null,
        adresseLocalisation: null,
        compagnieTransportRaisonSociale: null,
      },

      gareListObject: {
        data: {
          compagnieTransportRaisonSociale: null,
        },
      },

      gareUpdatingToSend: {
        datas: [],
      },

      gareDisponiblesList: [],
      options: {
        index: 0,
        size: 8,
      },
    };
  },

  methods: {
    // OPEN DIALOG FOR UPDATING STATION
    activeModeUpdating(station) {
      this.openDialogUpdatingStation = true;
      this.gareTransportModel.id = station.id;
      this.gareTransportModel.designation = station.designation;
      this.gareTransportModel.email = station.email;
      this.gareTransportModel.telephone1 = station.telephone1;
      this.gareTransportModel.telephone2 = station.telephone2;
      this.gareTransportModel.adresseLocalisation = station.adresseLocalisation;
      this.gareTransportModel.compagnieTransportRaisonSociale =
        station.compagnieTransportRaisonSociale;
    },

    async apiUpdateGareTransport() {
      this.closeDialogUpdatingStation();
      const checkStation =
        this.gareTransportModel.designation != null &&
        this.gareTransportModel.designation !== "" &&
        this.gareTransportModel.email != null &&
        this.gareTransportModel.email !== "" &&
        this.gareTransportModel.telephone1 != null &&
        this.gareTransportModel.telephone1 !== "" &&
        this.gareTransportModel.adresseLocalisation != null &&
        this.gareTransportModel.adresseLocalisation !== "";

      if (!checkStation) {
        this.errorMsg = this.$t('station.requiredFieldsError');
        showErrorMessage();
      } else {
        this.gareUpdatingToSend.datas.push(this.gareTransportModel);
        this.overlay = true;
        await axios
          .put(API_CREER_GARE_COMPAGNIE_TRANSPORT, this.gareUpdatingToSend, {
            headers: HEADERS(this.$store.state.userAuthentified.token),
          })
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code == 800) {
                this.successMsg = response.data.status.message;
                showSuccessMessage();
                this.gareUpdatingToSend.datas = [];
              } else {
                this.errorMsg = response.data.status.message;
                showErrorMessage();
              }
            } else {
              this.errorMsg = this.$t('station.creationError');
              showErrorMessage();
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            showErrorMessage();
          })
          .finally(() => {
            this.gareUpdatingToSend.datas = [];
            this.overlay = false;
          });
      }
    },

    closeDialogUpdatingStation() {
      this.openDialogUpdatingStation = false;
    },

    // Get all stations by Compagnie
    async getAllAvailableStationByCompagnie(compagnieTransport) {
      this.gareListObject.data.compagnieTransportRaisonSociale =
        compagnieTransport;
      this.loading = true;
      
      try {
        // ✅ Utilise apiService avec cache automatique
        const response = await apiService.postForGet(
          'gares/getGareByCompagnieTransportRaisonScoiale',
          this.gareListObject
        );
        
        if (response.status.code != 800) {
          this.errorMsg = response.status.message;
          showErrorMessage();
        } else {
          this.gareDisponiblesList = response.items;
        }
      } catch (e) {
        this.errorMsg = e;
        showErrorMessage();
      } finally {
        this.loading = false;
        this.cardForAvailableStationShowed = true;
      }
    },

    // RECUPERER LA LISTE DES GARES ENREGISTRÉS PAR COMPAGNIE DE TRANSPORT
    async obtenirGareListParCompagnieTransport() {
      if (
        this.$store.state.userAuthentified.roleCode !== "RoleAdminSocieteMere"
      ) {
        this.loading = true;
        this.gareListObject.data.compagnieTransportRaisonSociale =
          this.$store.state.userAuthentified.compagnieTransportRaisonSociale;
        
        try {
          // ✅ Utilise apiService avec cache automatique
          const response = await apiService.postForGet(
            'gares/getGareByCompagnieTransportRaisonScoiale',
            this.gareListObject
          );
          
          if (response.status.code != 800) {
            this.errorMsg = response.status.message;
            showErrorMessage();
          } else {
            this.gareDisponiblesList = response.items;
          }
        } catch (e) {
          this.errorMsg = e;
          showErrorMessage();
        } finally {
          this.loading = false;
        }
      }
    },

    // OBTENIR LA LISTE DES DEMANDES D'ADHESIONS VALIDÉES
    async getCompagnieTransportList() {
      if (
        this.$store.state.userAuthentified.roleCode == "RoleAdminSocieteMere"
      ) {
        await axios
          .post(
            API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
            this.options,
            {
              headers: HEADERS(this.$store.state.userAuthentified.token),
            }
          )
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code != 800) {
                this.errorMsg = response.data.status.message;
                showErrorMessage();
              } else {
                this.compagnieTransportList = response.data.items;
              }
            } else {
              this.errorMsg = "Erreur lors de la récupération des données";
              showErrorMessage();
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            showErrorMessage();
          });
      }
    },
  },

  mounted() {
    this.getCompagnieTransportList();
    this.obtenirGareListParCompagnieTransport();
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/admin/ui";

.gs-company {
  max-width: 480px;
}

.gs-designation {
  font-weight: 700;
  color: $ov-navy;
}

.gs-dialog-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
</style>
